import styled from "styled-components";

import {
  Block,
  FontWeight,
  Color,
} from '../../../../styles'

export const TextContainer = styled(Block)`
  background-color: ${props => props.bgColor};
  box-sizing: border-box;
  padding: ${props => 'mobile' === props.currDevice ? `2em` : `2.3vw 1.5vw 2.1vw`};
  border-radius: 8px;
  margin-bottom: 1em;

  h1,
  h2,
  h3
  {
    font-weight: ${FontWeight.bold};
    font-size: 2.1em;
    margin-top: ${props => props.disableMargins ? '0' : '0.2em'};
    margin-bottom: ${props => props.disableMargins ? '0' : '1.5em'};
    text-transform: none;
  }

  h4,
  h5,
  h6 {
    font-weight: ${FontWeight.semiBold};
    font-size: 1.4em;
    line-height: 1.35em;
    margin-top: ${props => props.disableMargins ? '0' : '0.2em'};
    margin-bottom: ${props => props.disableMargins ? '0' : '0.2em'};
    text-transform: none;
  }

  p {
    font-size: 1.4em;
    line-height: 1.43em;
    margin-top: ${props => props.disableMargins ? '0' : '0.2em'};
    margin-bottom: ${props => props.disableMargins ? '0' : '1.4em'};
  }

  a {
    color: ${Color.red} !important;
  }
`